<app-background-animation></app-background-animation>
<div class="accept-invite-container">
    <div class="invite-card">
        <mat-card>
            <mat-card-header>
                <div class="rotating-logo"></div>
            </mat-card-header>
            <mat-card-content>
                <div *ngIf="!message">
                    <mat-spinner></mat-spinner>
                    <h2>Taking you to REMOAT...</h2>
                </div>
                <div *ngIf="message">
                    <h2>REMOAT</h2>
                    <p>{{ message }}</p>
                    <button *ngIf="signInFirst" mat-flat-button color="primary" (click)="signIn()">Sign in to MedicAI</button>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>
